<template>

  <h2>Zoznam kurzov</h2>

  <!-- Navigácia mesiacov -->
  <v-row align="center" style="margin:1px">
    <v-btn size="small" variant="outlined" style="margin-right:8px;" @click="prevMonth">‹</v-btn>
    <span style="margin-right:8px; font-weight:bold">{{ formatMonthLabel(currentYear, currentMonth) }}</span>
    <v-btn size="small" variant="outlined" style="margin-right:1px" @click="nextMonth">›</v-btn>
    <v-btn size="small" variant="outlined" style="margin-right:1px" @click="goToday">Dnes</v-btn>
    <v-spacer />
    <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 0">Kalendár</v-btn>
    <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 1">Zoznam</v-btn>
  </v-row>

  <!-- Filtre: 2 skupiny -->
  <v-row align="center" style="margin:6px 1px">
    <span style="margin-right:6px"><b>Miesto:</b></span>
    <v-btn size="x-small" variant="outlined" style="margin-right:4px"
           :color="isVenueOn('OBJ') ? 'success' : ''"
           @click="toggleVenue('OBJ')">
      U objednávateľa
    </v-btn>
    <v-btn size="x-small" variant="outlined" style="margin-right:16px"
           :color="isVenueOn('UKF') ? 'success' : ''"
           @click="toggleVenue('UKF')">
      UKF
    </v-btn>

    <span style="margin-right:6px"><b>Skupina:</b></span>
    <v-btn size="x-small" variant="outlined" style="margin-right:4px"
           :color="isAudienceOn('ST') ? 'success' : ''"
           @click="toggleAudience('ST')">
      Študenti/Žiaci
    </v-btn>
    <v-btn size="x-small" variant="outlined" style="margin-right:8px"
           :color="isAudienceOn('UC') ? 'success' : ''"
           @click="toggleAudience('UC')">
      Učitelia
    </v-btn>

    <v-btn size="x-small" variant="outlined" @click="clearFilters">Vymazať</v-btn>

    <v-spacer />
    <span v-for="tag in legendTags" :key="tag.key" :style="legendStyle(tag.key)">{{ tag.label }}</span>
  </v-row>

  <!-- Kalendár -->
  <v-card-text v-if="toggle_select==0">
    <table border="1" style="padding:0px;spacing:0px;border-collapse:collapse;width:100%;table-layout:fixed">
      <tr style="background:#f5f5f5">
        <th v-for="d in ['Po','Ut','St','Št','Pi','So','Ne']" :key="d" style="background-color:#2E7D32;color:white;padding:5px;width:14.2857%">{{ d }}</th>
      </tr>
      <tr v-for="(week, wi) in weeks" :key="wi">
        <td v-for="(day, di) in week" :key="di" valign="top" :style="getDayCellStyle(day)">
          <div style="display:flex;justify-content:space-between;align-items:center">
            <span style="font-weight:bold">{{ day.day }}</span>
            <v-icon v-if="day.isToday" style="color:#2E7D32" size="14px" title="Dnes">fiber_manual_record</v-icon>
          </div>

          <!-- udalosti v dni -->
          <v-tooltip v-for="(sk, si) in day.skolenia" :key="si" location="top">
            <template #activator="{ props }">
              <v-card
                v-bind="props"
                variant="outlined"
                :style="getCourseCardStyle(sk)"                
              >
                <v-card-text style="margin:-5px">
                  <!-- názov sa zalamuje na viac riadkov -->
                  <div style="font-weight:600; white-space:normal; word-break:break-word; line-height:1.2">{{ sk.nazov }}</div>
                  <div style="font-size:12px">{{ sk.cas }}</div>
                  <div style="font-size:12px">
                    Prihlásení: {{ safeCount(sk) }} / {{ effectiveMax(sk) }}
                  </div>
                  <div style="margin-top:3px">
                    <span v-for="chip in makeChips(sk)" :key="chip.key" :style="chipStyle(chip.key)">{{ chip.label }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </template>

            <!-- tooltip s kompletnými informáciami -->
            <div style="max-width:380px">
              <div style="font-weight:bold;margin-bottom:4px">{{ sk.nazov }}</div>
              <div><b>Dátum:</b> {{ sk.datum }} &nbsp; <b>Čas:</b> {{ sk.cas || '—' }}</div>
              <div><b>Miesto:</b> {{ sk.miesto_konania || '—' }}</div>
              <div><b>Cieľová skupina:</b> {{ sk.cielova_skupina || '—' }}</div>
              <div><b>Dĺžka:</b> {{ sk.dlzka || '—' }}</div>
              <div><b>Požadované znalosti:</b> {{ sk.pozadovane_znalosti || '—' }}</div>
              <div><b>Technické vybavenie:</b> {{ sk.technicke_vybavenie || '—' }}</div>
              <div><b>Poznámky:</b> {{ sk.poznamky || '—' }}</div>
              <div><b>Účastníci:</b> prihlásení {{ safeCount(sk) }} / max {{ effectiveMax(sk) }} <span v-if="sk.min_ucastnikov"> (min {{ sk.min_ucastnikov }})</span></div>
              <div><b>Skratka:</b> {{ sk.skratka || '—' }}</div>
              <div style="margin-top:4px">
                <span v-for="chip in makeChips(sk)" :key="chip.key" :style="chipStyle(chip.key)">{{ chip.label }}</span>
              </div>
            </div>
          </v-tooltip>

        </td>
      </tr>
    </table>
  </v-card-text>

  <!-- Zoznam -->
  <v-card-text v-if="toggle_select==1">
    <table border="1" style="padding:0px;spacing:0px;border-collapse:collapse;width:100%">
      <tr style="background-color:#2E7D32;color:white;padding:5px">
        <th style="padding:5px">Dátum</th>
        <th style="padding:5px">Čas</th>
        <th style="padding:5px">Názov</th>
        <th style="padding:5px">Popis (miesto, cieľová skupina)</th>
        <th style="padding:5px">Požadované znalosti</th>
        <th style="padding:5px">Technické vybavenie</th>
        <th style="padding:5px">Prihl./Min/Max</th>
        <th style="padding:5px">Poznámky</th>
      </tr>
      <tr v-for="(sk, i) in zoznamSkoleni" :key="i" :style="getListRowStyle(sk)">
        <td style="padding:5px">{{ sk.datum }}</td>
        <td style="padding:5px">{{ sk.cas }}</td>
        <td style="padding:5px">
          <v-tooltip location="top">
            <template #activator="{ props }">
              <span v-bind="props" style="white-space:normal; word-break:break-word; line-height:1.2">{{ sk.nazov }}</span>
            </template>
            <div style="max-width:380px">
              <div style="font-weight:bold;margin-bottom:4px">{{ sk.nazov }}</div>
              <div><b>Dátum:</b> {{ sk.datum }} &nbsp; <b>Čas:</b> {{ sk.cas || '—' }}</div>
              <div><b>Miesto:</b> {{ sk.miesto_konania || '—' }}</div>
              <div><b>Cieľová skupina:</b> {{ sk.cielova_skupina || '—' }}</div>
              <div><b>Dĺžka:</b> {{ sk.dlzka || '—' }}</div>
              <div><b>Požadované znalosti:</b> {{ sk.pozadovane_znalosti || '—' }}</div>
              <div><b>Technické vybavenie:</b> {{ sk.technicke_vybavenie || '—' }}</div>
              <div><b>Účastníci:</b> prihlásení {{ safeCount(sk) }} / max {{ effectiveMax(sk) }} <span v-if="sk.min_ucastnikov"> (min {{ sk.min_ucastnikov }})</span></div>
              <div><b>Skratka:</b> {{ sk.skratka || '—' }}</div>
              <div style="margin-top:4px">
                <span v-for="chip in makeChips(sk)" :key="chip.key" :style="chipStyle(chip.key)">{{ chip.label }}</span>
              </div>
            </div>
          </v-tooltip>
        </td>
        <td style="padding:5px">
          <span v-for="chip in makeChips(sk)" :key="chip.key" :style="chipStyle(chip.key)">{{ chip.label }}</span>
        </td>
        <td style="padding:5px">{{ sk.pozadovane_znalosti }}</td>
        <td style="padding:5px">{{ sk.technicke_vybavenie }}</td>
        <td style="padding:5px" align="center">
          {{ safeCount(sk) }} / <span v-if="sk.min_ucastnikov">{{ sk.min_ucastnikov }}/</span>{{ effectiveMax(sk) }}
        </td>
        <td style="padding:5px">{{ sk.poznamky }}</td>
      </tr>
    </table>
  </v-card-text>

</template>

<script>
import axios from '../../axios-auth.js'

export default {
  data() {
    const now = new Date()
    return {
      toggle_select: 0,
      currentYear:  now.getFullYear(),
      currentMonth: now.getMonth() + 1,
      myKalendar: [],
      weeks: [],
      eventsByDate: {},
      // 2 skupiny filtrov
      activeVenue: new Set(['OBJ','UKF']),
      activeAudience: new Set(['ST','UC']),
      palette: {
        OBJ: { bg:'#FFF3E0', fg:'#E65100' }, // u objednávateľa
        UKF: { bg:'#E8F5E9', fg:'#2E7D32' }, // na UKF
        ST:  { bg:'#E3F2FD', fg:'#0D47A1' }, // študenti/žiaci
        UC:  { bg:'#F3E5F5', fg:'#6A1B9A' }, // učitelia
        DEF: { bg:'#ECEFF1', fg:'#37474F' }
      }
    }
  },

  mounted() {
    this.initData()
  },

  computed: {
    zoznamSkoleni() {
      const arr = this.applyFilters(this.myKalendar)
      arr.sort((a,b) => (`${a.datum} ${a.cas||''}` < `${b.datum} ${b.cas||''}` ? -1 : 1))
      return arr
    },
    legendTags() {
      return [
        { key:'OBJ', label:'U objednávateľa' },
        { key:'UKF', label:'UKF' },
        { key:'ST',  label:'Študenti/Žiaci' },
        { key:'UC',  label:'Učitelia' }
      ]
    }
  },

  methods: {
    initData() {
      this.$store.commit('setFeedback', null)
      this.fetchMonth(this.currentYear, this.currentMonth)
    },

    fetchMonth(rok, mesiac) {
      const mm = String(mesiac).padStart(2,'0')
      axios.get(`/get-kalendar-skoleni/${rok}/${mm}`, this.$store.getters.getAxiosConfig)
        .then(res => {
          // očakávané položky kurzov: ... , max_ucastnikov, min_ucastnikov, pocet_prihlasenych
          this.myKalendar = Array.isArray(res.data?.skolenia) ? res.data.skolenia : []
          if (res.data?.message && res.data.message !== 'OK') this.$store.commit('setFeedback', res.data.message)
          this.prepareCalendar(rok, mesiac)
        })
        .catch(error => {
          this.$store.commit('setFeedback', error.name+': '+error.message)
          this.myKalendar = []
          this.prepareCalendar(rok, mesiac)
        })
    },

    prepareCalendar(rok, mesiac) {
      const filtered = this.applyFilters(this.myKalendar)
      const map = {}
      for (const el of filtered) {
        const key = String(el.datum)
        if (!map[key]) map[key] = []
        map[key].push(el)
      }
      Object.keys(map).forEach(k => map[k].sort((a,b) => (a.cas||'') < (b.cas||'') ? -1 : 1))
      this.eventsByDate = map

      const first = new Date(rok, mesiac - 1, 1)
      const last  = new Date(rok, mesiac, 0)
      const days  = last.getDate()
      const jsDow = first.getDay() // 0=Ne..6=So
      const offset = (jsDow === 0 ? 6 : jsDow - 1)

      const cells = []
      for (let i=0; i<offset; i++) {
        const d = new Date(first); d.setDate(d.getDate() - (offset - i))
        cells.push(this.makeDayCell(d, false))
      }
      for (let day=1; day<=days; day++) {
        const d = new Date(rok, mesiac-1, day)
        cells.push(this.makeDayCell(d, true))
      }
      while (cells.length % 7 !== 0) {
        const d = new Date(last); d.setDate(d.getDate() + (cells.length % 7))
        cells.push(this.makeDayCell(d, false))
      }
      const weeks = []
      for (let i=0; i<cells.length; i+=7) weeks.push(cells.slice(i, i+7))
      this.weeks = weeks
    },

    makeDayCell(dateObj, inMonth) {
      const y = dateObj.getFullYear()
      const m = String(dateObj.getMonth()+1).padStart(2,'0')
      const d = String(dateObj.getDate()).padStart(2,'0')
      const key = `${y}-${m}-${d}`
      const now = new Date()
      const isToday = (y===now.getFullYear() && (dateObj.getMonth()+1)===(now.getMonth()+1) && dateObj.getDate()===now.getDate())
      return { date:key, day:parseInt(d,10), inMonth, isToday, skolenia:this.eventsByDate[key] || [] }
    },

    // navigácia
    prevMonth(){ let y=this.currentYear, m=this.currentMonth-1; if(m===0){m=12;y--} this.currentYear=y; this.currentMonth=m; this.fetchMonth(y,m) },
    nextMonth(){ let y=this.currentYear, m=this.currentMonth+1; if(m===13){m=1;y++} this.currentYear=y; this.currentMonth=m; this.fetchMonth(y,m) },
    goToday(){ const n=new Date(); this.currentYear=n.getFullYear(); this.currentMonth=n.getMonth()+1; this.fetchMonth(this.currentYear,this.currentMonth) },

    formatMonthLabel(y, m) {
      const names = ['január','február','marec','apríl','máj','jún','júl','august','september','október','november','december']
      return `${names[m-1]} ${y}`
    },

    getDayCellStyle(day) {
      let st = 'height:140px; padding:4px; overflow:auto;'
      if (!day.inMonth) st += 'background:#fafafa;color:#999;'
      if (day.isToday)  st += 'border:2px solid #2E7D32;'
      return st
    },

    /* ===== Obsadenosť & vzhľad karty ===== */
    safeCount(sk) {
      const n = Number(sk?.pocet_prihlasenych ?? 0)
      return isNaN(n) ? 0 : n
    },
    effectiveMax(sk) {
      // preferuj back-end hodnotu; fallback: ak je „u objednávateľa“ a chýba max, ber 1
      if (sk?.max_ucastnikov != null) return Number(sk.max_ucastnikov)
      return this.venueKeyFrom(sk?.miesto_konania) === 'OBJ' ? 1 : null
    },
    isFull(sk) {
      const cnt = this.safeCount(sk)
      const mx  = this.effectiveMax(sk)
      if (mx == null) return false
      return cnt >= mx
    },
    getCourseCardStyle(sk) {
      const base = 'margin:2px;overflow:hidden;'
      // bledozelené vs. bledočervené
      const bg  = this.isFull(sk) ? '#FFEBEE' : '#E8F5E9'
      const brd = this.isFull(sk) ? '#C62828' : '#2E7D32'
      return `${base}background:${bg};border:1px solid ${brd};`
    },
    getListRowStyle(sk) {
      // jemné podfarbenie riadku podľa obsadenosti (voliteľné)
      const bg = this.isFull(sk) ? '#FFEBEE' : ''
      return bg ? `background:${bg};` : ''
    },

    // --- chips (štítky) ---
    makeChips(sk) {
      const chips = []
      const v = this.venueKeyFrom(sk.miesto_konania)
      if (v) chips.push({ key:v, label:this.labelOf(v) })
      const a = this.audienceKeysFrom(sk.cielova_skupina)
      a.forEach(k => chips.push({ key:k, label:this.labelOf(k) }))
      return chips
    },
    labelOf(key) {
      if (key==='OBJ') return 'U objednávateľa'
      if (key==='UKF') return 'UKF'
      if (key==='ST')  return 'Študenti'
      if (key==='UC')  return 'Učitelia'
      return key
    },
    chipStyle(key) {
      const c = this.palette[key] || this.palette.DEF
      return `display:inline-block;margin:1px 4px 0 0;padding:2px 6px;border-radius:10px;font-size:11px;
              background:${c.bg};color:${c.fg};border:1px solid ${c.fg}22;`
    },
    legendStyle(key) { return this.chipStyle(key) },

    // --- rozpoznanie filtrov ---
    venueKeyFrom(miesto='') {
      const s = String(miesto).toLowerCase()
      if (s.includes('ukf') || s.includes('univerzit') || s.includes('kampus')) return 'UKF'
      return 'OBJ'
    },
    audienceKeysFrom(cg='') {
      const s = String(cg).toLowerCase()
      const keys = []
      if (s.includes('študenti') || s.includes('žiaci') || s.includes('študent') || s.includes('student')) keys.push('ST')
      if (s.includes('učitelia') || s.includes('ucitel') || s.includes('teacher') || s.includes('pedag')) keys.push('UC')
      return keys
    },

    // --- filtre toggles ---
    toggleVenue(key){ this.activeVenue.has(key) ? this.activeVenue.delete(key) : this.activeVenue.add(key); this.prepareCalendar(this.currentYear, this.currentMonth) },
    toggleAudience(key){ this.activeAudience.has(key) ? this.activeAudience.delete(key) : this.activeAudience.add(key); this.prepareCalendar(this.currentYear, this.currentMonth) },
    isVenueOn(key){ return this.activeVenue.has(key) },
    isAudienceOn(key){ return this.activeAudience.has(key) },
    clearFilters(){
      this.activeVenue = new Set()
      this.activeAudience = new Set()
      this.prepareCalendar(this.currentYear, this.currentMonth)
    },

    // aplikovanie filtrov (AND medzi skupinami; prázdna skupina = pass-through)
    applyFilters(events) {
      return events.filter(sk => {
        const v = this.venueKeyFrom(sk.miesto_konania)
        const a = this.audienceKeysFrom(sk.cielova_skupina)

        const venueOk = (this.activeVenue.size === 0) || this.activeVenue.has(v)
        const audienceOk = (this.activeAudience.size === 0) || a.some(k => this.activeAudience.has(k))
        return venueOk && audienceOk
      })
    },

    // klik na kurz – prispôsob si route
    openKurz(sk) { console.log('OPEN', sk) }
  }
}
</script>
